import { NgModule, APP_INITIALIZER } from '@angular/core';
import { MsalGuard, MsalBroadcastService, MsalModule, MsalService, MsalRedirectComponent, MSAL_INSTANCE, MSAL_GUARD_CONFIG, MSAL_INTERCEPTOR_CONFIG, MsalGuardConfiguration, MsalInterceptorConfiguration } from '@azure/msal-angular';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ApplicationRoutingModule } from './application/application-routing/application-routing.module';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LayoutComponent } from './application/layouts/layout/layout.component';
import { LoginAuthenticationGuardService } from './auth/guards/login-authentication-guard.service';
import { PublicClientApplication, IPublicClientApplication } from '@azure/msal-browser';
import { InteractionType, BrowserCacheLocation } from '@azure/msal-browser';
import { AuthInterceptorService } from './auth/auth-interceptor.service';
import { SharedModule } from './application/shared/shared/shared.module';
import {LoaderInterceptor} from './loaderInterceptor.service';
import { TimeoutInterceptor } from './timeout-interceptor.service';
import { ConfigInitializerService } from './services/config-initializer.service';

// Factory function to initialize config before app starts
export function initializeApp(configService: ConfigInitializerService) {
  return (): Promise<void> => {
    return configService.loadConfig();
  };
}

// Factory function to create MSAL instance with dynamic client ID
export function MSALInstanceFactory(configService: ConfigInitializerService): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: configService.getMicrosoftClientId() || '',
      authority: 'https://login.microsoftonline.com/common/',
      redirectUri: window.location.origin,
      postLogoutRedirectUri: window.location.origin,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: true,
    },
    system: {
      loggerOptions: {
        loggerCallback: () => {},
        piiLoggingEnabled: false,
      },
    },
  });
}

// Factory function for MSAL Guard Configuration
export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
  };
}

// Factory function for MSAL Interceptor Configuration
export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap: new Map([
      ['https://pilotbird-claim-prod-api.pilotbird.com/*', ['customscope.read']],
    ]),
  };
}

@NgModule({
  declarations: [
    AppComponent,
    LayoutComponent,
  ],
  imports: [
    AppRoutingModule,
    ApplicationRoutingModule,
    SharedModule,
    CommonModule,
    BrowserAnimationsModule,
    MsalModule,
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [ConfigInitializerService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true 
    },
    {
      provide: HTTP_INTERCEPTORS, useClass: TimeoutInterceptor, multi: true 
    },
    LoginAuthenticationGuardService,
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory,
      deps: [ConfigInitializerService]
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
  ],
  bootstrap: [AppComponent, MsalRedirectComponent],
})
export class AppModule {}